import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

function initTestimonialSliders() {
    document.querySelectorAll('.testimonials-swiper').forEach((el) => {
        if (el.swiper) return;

        const section = el.closest('.testimonials-section');
        if (!section) return;

        new Swiper(el, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 400,
            breakpoints: {
                768: { slidesPerView: 2, spaceBetween: 32 },
            },
            navigation: {
                prevEl: section.querySelector('.testimonials-prev'),
                nextEl: section.querySelector('.testimonials-next'),
            },
        });

        section.classList.add('swiper-ready');
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSliders);
} else {
    initTestimonialSliders();
}
